import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { AssemblyJig } from 'app/core/model/assembly-jig';
import { OrderLineDetail } from 'app/core/model/order-line-detail';
import { OrderLineStatus } from 'app/core/model/order-line-status';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxSchedulerComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-order-scheduler',
    templateUrl: './order-scheduler.component.html',
    styleUrls: ['./order-scheduler.component.scss'],
    standalone: false
})
export class OrderSchedulerComponent implements OnInit {
    filter: { statuses: string[] };
    statuses: string[];
    orders: any;
    currentDate = new Date();
    schedulerData: any[] = [];
    statusColors: any[] = [
        { text: 'WIP', id: 99, color: '#006ccc' },
        { text: 'Pack Slip Created', id: 98, color: '#00adb9ff' },
        { text: 'Ready To Deliver', id: 97, color: '#cd5c5c' },
        { text: 'Jig Complete', id: 999, color: '#1abda5' },
        { text: 'Built', id: 2, color: '#006600' },
        { text: 'Stacked', id: 3, color: '#00af2c' },
        { text: 'Delivered', id: 9, color: '#777777' },
    ];
    selectedDate: Date;

    cellContextMenuItems: any;
    appointmentContextMenuItems: any;
    contextMenuCellData: any;
    contextMenuAppointmentData: any;
    contextMenuTargetedAppointmentData: any;

    @ViewChild('scheduler') scheduler: DxSchedulerComponent;

    constructor(protected uow: GenesisUnitOfWork, private modalService: BsModalService, private appInfo: AppInformationService, private sessionInfo: SessionInformationService) {
        this.cellContextMenuItems = [
            // { text: 'New Order', onItemClick: () => this.createAppointment() },
            { text: 'Go to Today', onItemClick: () => this.showCurrentDate() },
        ];

        this.appointmentContextMenuItems = [
            { text: 'Change Scheduled Date', onItemClick: () => this.changeScheduled() },
            // { text: 'Open Order', onItemClick: () => this.open() },
            // { text: 'View Details', onItemClick: () => this.view() },
        ];
    }

    ngOnInit() {
        this.getStatuses();
        this.filter = this.sessionInfo.getItem('order-scheduler-filter') ?? { statuses: ['WIP'] };
        this.getSchedulerData();
    }

    getStatuses() {
        // because we are combining WIP statuses, filter by status name, not id
        // only include statuses that are shown on screen
        const statuses = ['WIP'];
        const statusIds = [
            OrderLineStatus.OrderLineStatusOptions.Built,
            OrderLineStatus.OrderLineStatusOptions.Stacked,
            OrderLineStatus.OrderLineStatusOptions.ReadToDeliverPickup,
            OrderLineStatus.OrderLineStatusOptions.DeliveredPickedUp,
            OrderLineStatus.OrderLineStatusOptions.PackSlipCreated,
        ];
        statuses.push(...this.uow.lookups.orderLineStatuses.filter((status) => statusIds.some((id) => id === status.id)).map((status) => status.name));
        this.statuses = statuses;
    }

    statusChanged = async (e) => {
        await this.getSchedulerData();
        this.sessionInfo.setItem('order-scheduler-filter', this.filter);
    };

    async getSchedulerData() {
        const schedulerData = await this.uow.getSchedulerData(this.filter.statuses);
        // console.log('schedulerData', schedulerData);
        schedulerData.forEach((dataItem) => {
            console.log('dataItem', dataItem);
            dataItem.statusColorId = dataItem.statusId;
            dataItem.startDate = moment(dataItem.scheduled ? dataItem.scheduled : dataItem.buildDue).startOf('day').add(8, 'hours').toDate();
        });
        const grouped = Object.values(_.groupBy(schedulerData, 'startDate'));

        grouped.forEach((x) => {
            if (x.length > 1) {
                const trailers = Object.values(x);
                // const units = x.length > 24 ? 'minutes' : 'hours';
                // const unitAmount = x.length > 24 ? 30 : 1;
                const units = 'minutes';
                const unitAmount = 30;
                let i = 0;
                // console.log(i);
                trailers.forEach((trailer) => {
                    const find = _.find(schedulerData, { id: trailer.id });
                    find.startDate = moment(find.startDate).add(i * unitAmount, units);
                    i++;
                });
            }
        });
        // console.log(_.groupBy(schedulerData, 'startDate'));
        this.schedulerData = schedulerData;
    }

    onContentReady(e) {
        if (e.component._currentView === 'day' || e.component._currentView === 'week') {
            e.component.scrollToTime(7, 0);
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    onContextMenuItemClick(e) {
        e.itemData.onItemClick(e.itemData);
    }

    onCellContextMenu(e) {
        this.contextMenuCellData = e.cellData;
    }

    onAppointmentContextMenu(e) {
        this.contextMenuAppointmentData = e.appointmentData;
        this.contextMenuTargetedAppointmentData = e.targetedAppointmentData;
    }

    showCurrentDate() {
        this.currentDate = new Date();
    }

    onDoubleClick(e) {
        // prevents opening default scheduler dialog
        e.cancel = true;
    }

    onAppointmentUpdated = async (e) => {
        const orderLineDetailId = e.appointmentData?.id;
        const newDate = e.appointmentData?.startDate;
        if (!newDate || !orderLineDetailId) return;

        const orderLineDetail = (await this.uow.orderLineDetails.byId(orderLineDetailId)) as OrderLineDetail;
        orderLineDetail.scheduled = newDate;
        orderLineDetail.assemblyJigId = orderLineDetail.assemblyJigId ?? AssemblyJig.Jigs.Other;
    };

    async changeScheduled() {
        const orderLineDetailId = this.contextMenuAppointmentData?.id;
        if (!orderLineDetailId) return;

        const orderLineDetail = (await this.uow.orderLineDetails.byId(orderLineDetailId)) as OrderLineDetail;
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Change Scheduled Date',
                dialogValue: orderLineDetail.scheduled,
                mode: 'date',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result && !!result.value) {
                orderLineDetail.scheduled = result.value;
                const dataItem = this.schedulerData.find((i) => i.id === orderLineDetailId);
                if (dataItem) {
                    dataItem.startDate = result.value;
                    dataItem.endDate = moment(result.value).add(30, 'minutes').toDate();
                    this.scheduler.instance.repaint();
                }
            }
            modalRef.hide();
        });
    }

    async save() {
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        await this.getSchedulerData();
        this.appInfo.pleaseWaitHide();
    }

    async cancel() {
        const success = await confirm('Are you sure you want to cancel the changes?', this.appInfo.settings.company);
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        this.uow.rollback();
        await this.getSchedulerData();
        this.appInfo.pleaseWaitHide();
    }
}
